import React from "react";
import { ColorRing, ThreeDots } from "react-loader-spinner";
import { useLocation } from "react-router-dom";

const Loader = () => {
  const location = useLocation();
  return (
    <div className="loader_container">
      <div className="loader-inner">
        <div className="loader-content">
          <div>
            <img style={{ width: "80px" }} src="/metbrains-tp-1.png" />
          </div>
          <p style={{marginTop:"18px", color:"#fff"}}>Metbrains</p>
        </div>
      </div>
    </div>
  );
};

export const VideoLoader = () => {
  return (
    <div className="loader_container">
      <video
        muted
        autoPlay
        playsInline
        onEnded={(e)=>{}}
      >
        <source src="https://metbrains-demo-bucket.s3.ap-southeast-2.amazonaws.com/logo_reveal.mp4" type="video/mp4" />
      </video>
    </div>
  );
};

export default Loader;
